export default {
      id: "ic_raffle_prize-usage",
      viewBox: "0 0 31 63",
      url: "/" + "images/icons.3.109.2.svg#ic_raffle_prize-usage",
      toString: function () {
        return this.url;
      }
    }